export enum UsedByModule {
    Ticketing = 'travelx',
    TravelX = 'travelxnew',
    TravelRecruiting = 'recruiting',
    PerDiemRecruiting = 'perdiem-recruiting',
    StaffRecruiting = 'staff-recruiting',
    References = 'references',
    PerDiem = 'perdiem',
    AccessControl = 'access-control',
    FacilityContracts = 'facility-contracts',
    AccountManagers = 'account-managers',
    Payroll = 'payroll',
    Credentialing = 'credentialing',
    LocumsRecruiting = 'locums-recruiting',
    PartnerNetwork = 'partnernetwork',
    TravelContracts = 'travel-contracts'
}
